// @ts-expect-error - TS2305 - Module '"'@atlassian/jira-share-dialog"' has no exported member 'OptionData'.
import type { OptionData } from '@atlassian/jira-share-dialog/src/common/types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ServerUsersAndGroups } from '../../ui/share-view/types.tsx';

const USER_PICKER_LIMIT = 20;

export const loadUsers = async (searchText = ''): Promise<OptionData[]> => {
	const searchTextEncoded = encodeURIComponent(searchText);
	const url = `/rest/api/3/groupuserpicker?maxResults=${USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;

	const groupsAndUsers: ServerUsersAndGroups = await fetchJson(url);

	return groupsAndUsers.users.users
		.filter((user) => user.accountType === 'atlassian')
		.map((user) => ({
			type: 'user',
			id: user.accountId,
			name: user.displayName,
			avatarUrl: user.avatarUrl,
		}));
};
